import React, { useState } from "react";
import Header from "../Header";
import Sidebar from "../Sidebar";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { postOrgFeatureCategory } from "../../connections/postOrgFeatureCategory";
import { toast } from "react-toastify";

const OrganizationCategorySelect = () => {
  const [category, setCategory] = useState("");

  const {
    user: { user },
  } = useSelector((store) => store);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!category.trim()) {
      toast.error("Category is required");
      return;
    }

    try {
      const result = await postOrgFeatureCategory(user?.token, category);

      if (result) {
        toast.success("Category Created Successfully");
        setCategory("");
      }
    } catch (error) {
      console.log(error);
      toast.error("Something went wrong");
    }
  };

  return (
    <div>
      <Header />
      <Sidebar activeClassName="origination--list" />

      <div className="page-wrapper">
        <div className="content">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={-1}>Organization Feature</Link>
                  </li>

                  <li className="breadcrumb-item active">Create Category</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <form onSubmit={handleSubmit}>
                    <div className="row">
                      <div className="col-12">
                        <div className="form-heading">
                          <h4>Create Category</h4>
                        </div>
                      </div>

                      <div className="col-12 col-md-6">
                        <div className="form-group local-forms">
                          <label>
                            Category Name{" "}
                            <span className="login-danger">*</span>
                          </label>

                          <input
                            type="text"
                            className="form-control"
                            placeholder="Enter category name"
                            value={category}
                            onChange={(e) => setCategory(e.target.value)}
                          />
                        </div>
                      </div>

                      <div className="col-12">
                        <div className="doctor-submit text-end">
                          <button
                            type="submit"
                            className="btn btn-primary submit-form"
                          >
                            Create Category
                          </button>
                        </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrganizationCategorySelect;
